import * as React from "react";

import { ChevronLeft, ChevronRight } from "lucide-react";

import { SuiSettingIcon } from "../../icons";
import { cn } from "../../../utils";

export interface ListHeaderProps {
  title: string | React.ReactNode;
  isExpanded?: boolean;
  onSettingClick?: () => void;
  onExpandClick?: () => void;
  bgColor?: string;
  textClassName?: string;
  titleIcon?: React.ReactNode;
  rightActions?: React.ReactNode;
  className?: string;
}

const ListHeader: React.FC<ListHeaderProps> = ({
  title,
  titleIcon,
  isExpanded = false,
  bgColor = "bg-[#82B495]",
  textClassName = "text-white",
  onSettingClick,
  onExpandClick,
  rightActions,
  className
}) => {
  return (
    <div data-testid="list-header" className={cn("rounded-t-lg px-4 py-2", bgColor, className)}>
      <div className="flex items-center justify-between">
        <div className={cn("flex items-center gap-2 text-lg", textClassName)}>
          {titleIcon}
          <p className="leading-none">{title}</p>
        </div>

        <div className="flex items-center gap-2">
          {rightActions ?? (
            <>
              {onSettingClick && (
                <button
                  onClick={onSettingClick}
                  title="Settings"
                  className="rounded p-1 hover:cursor-pointer hover:bg-white/20"
                >
                  <SuiSettingIcon className="text-white" />
                </button>
              )}

              {onSettingClick && onExpandClick && (
                <div className={cn("h-8 w-px", textClassName.replace("text-", "bg-"))} />
              )}

              {onExpandClick && (
                <button
                  data-testid="list-expand-button"
                  onClick={onExpandClick}
                  title={isExpanded ? "Collapse" : "Expand"}
                  className="rounded p-1 hover:cursor-pointer hover:bg-white/20"
                >
                  <span className="flex items-center gap-[2px] text-white">
                    {isExpanded ?
                      <>
                        <ChevronLeft className="h-4 w-4" />
                        <ChevronRight className="h-4 w-4 -ml-2" />
                      </>
                    : <>
                        <ChevronRight className="h-4 w-4" />
                        <ChevronLeft className="h-4 w-4 -ml-2" />
                      </>
                    }
                  </span>
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListHeader;
